<template>
  <div class="logistics">
    <div class="content_box">
      <div class="scroll_content">
        <div class="good_info_box">
          <img class="good_img" :src="data.logoAddress" v-if="data.logoAddress" />
          <div class="fast_mail_box">
            <div class="fast_mail_company">
              快递公司：<span>{{ data.expressCompany }}</span>
            </div>
            <div class="fast_mail_no">
              快递单号：<span>{{ data.expressBunber }}</span
              ><span class="copy_text" @click="copyNo">复制</span>
            </div>
          </div>
        </div>
        <div>
          <van-steps
            direction="vertical"
            inactive-color="#666666"
            active-color="#3377FF"
            :active="0"
          >
            <van-step v-for="(item, index) in list" :key="index">
              <div class="logistics_info">{{ item.status }}</div>
              <div class="logistics_time">{{ item.time }}</div>
            </van-step>
          </van-steps>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {}, //物流列表数据
      orderNo: "",
      list: [],
      sendExpressBunber: ""
    };
  },
  methods: {
    init() {
      this.$API.z_order.getExpressInfo(this.sendExpressBunber,this.orderNo).then((res) => {
        this.data = res.data;
        this.list = JSON.parse(this.data.expressTrack);
      });
    },
    copyNo() {
      console.log("copy");
    },
  },
  mounted() {
    this.orderNo = this.$route.query.orderNo;
    this.sendExpressBunber = this.$route.query.sendExpressBunber;
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.logistics {
  background-color: #f4f6f9;
  padding-top: vw(20);
  height: 100%;
  .content_box {
    overflow: hidden;
    margin: vw(24) vw(32);
    background-color: #fff;
    border-radius: vw(12);
    .scroll_content {
      height: 100%;
      overflow-y: scroll;
      .good_info_box {
        padding: vw(24) vw(31);
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: vw(1) #eef0f3 solid;
        .good_img {
          width: vw(120);
          height: vw(120);
          border-radius: vw(8);
          object-fit: cover;
          margin-right: vw(24);
        }
        .fast_mail_box {
          height: vw(90);
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          color: #666666;
          font-size: vw(28);
          .fast_mail_company {
            span {
              color: #333333;
            }
          }
          .fast_mail_no {
            span {
              color: #333333;
            }
            .copy_text {
              display: inline-block;
              margin-left: vw(15);
              color: $theme-color;
            }
          }
        }
      }
    }
  }
}
</style>
